module.exports = __webpack_public_path__ + "img/file-medical.fa5f780c.svg";